import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App";
import ReportingPeriod from "../../../components/Regulation/ReportingPeriod";
import Utils from "../../../core/utilities/Utils";
import CompanyService from "../../../core/service/CompanyService";
import Multiselect from "multiselect-react-dropdown";
import CarbonEmissionService from "../../../core/service/CarbonEmissionService";
import { BiCaretUp, BiX } from "react-icons/bi";


const CarbonEmissionFilter = ({ t, forCalculator = false, onApplyFilter, onFilterHide }) => {

	const { glbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ?? "";
	const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
	const year = new Date().getFullYear();
	const [ghgValues, setGhgvalues] = useState([])
	const [filter, setFilter] = useState({
		reportingPeriod: `${year}-${month}-01`,
		entity: '',
		emissionTable: 'DEFRA',
		ghgUnit: '',
		businessUnits: []
	});
	const [entities, setEntities] = useState([]);

	useEffect(() => {
		fetchEntities(filter.reportingPeriod);
		getGHGOptions()
	}, []);

	const fetchEntities = (period) => {
		const l1 = CompanyService.getEnterprisesByLevel(1);
		const l2 = CompanyService.getEnterprisesByLevel(2);
		Promise.all([l1, l2]).then(res => {
			const level1 = res[0].data;
			const level2 = res[1].data;

			const data = [];
			level1?.sort((a, b) => a.sortOrder - b.sortOrder)?.forEach(d => data.push(d));
			level2?.sort((a, b) => a.sortOrder - b.sortOrder)?.forEach(d => data.push(d));
			setEntities(data);
			const f = { ...filter, entity: data[0].id, reportingPeriod: period };
			setFilter(f);
			onApplyFilter(f);
		}).catch(err => { });
	};

	const setReportingPeriod = (period) => {
		const f = { ...filter, reportingPeriod: `${period.year}-${period.month}-01` };
		setFilter(f);
		if (!forCalculator) return;
	};

	const setEntity = (val) => {
		const f = { ...filter, entity: val };
		setFilter(f);
		if (!forCalculator) return;
	};


	const onSelectDeSelectEntity = (item) => {
		const units = [...filter.businessUnits];
		const index = filter.businessUnits.indexOf(item.id);
		if (index >= 0) {
			units.splice(index, 1);
		} else {
			units.push(item.id);
		}
		setFilter({
			...filter,
			businessUnits: units
		});
	};

	const getSelectedEntities = () => {
		const data = [];
		entities?.forEach(e => {
			if (filter.businessUnits.indexOf(e.id) < 0) return;

			data.push(e);
		});
		return data;
	};

	const getGHGOptions = () => {
		CarbonEmissionService.getGhgOpt().then(res => {
			if (res.status !== 200) return;
			setGhgvalues(res.data.data)
		}).catch(err => { });
	};

	const resetFilter = () => {
		if (forCalculator) {
			setFilter({
				reportingPeriod: `${year}-${month}-01`,
			});
			fetchEntities(`${year}-${month}-01`);
		} else {
			setFilter({
				reportingPeriod: `${year}-${month}-01`,
				emissionTable: 'DEFRA',
				ghgUnit: '',
				businessUnits: []
			});
			const filterToSend = {
				reportingPeriod: `${year}-01-01`,
				emissionTable: 'DEFRA',
				ghgUnit: '',
				businessUnits: []
			};
			onApplyFilter(filterToSend);
		}
	}

	return (
		<div className="Main_filter 3">
			<div className="Main_filter_head">
				<h5>{t("Filter.label")}</h5>
				<div className="btnClose" onClick={()=>onFilterHide(false)}>
					<BiX />
				</div>
			</div>
			<div className="Main_filter_body">
				<div className="row m-0">
					<div className="col-8 p-2">
						<label>{t("ReportingPeriod.label")}</label>
						<ReportingPeriod
							defaultPeriod={filter.reportingPeriod}
							valueChangeCallback={(period) => setReportingPeriod(period)} />
					</div>
					{
						forCalculator &&
						<div className="col-4 p-2">
							<label htmlFor="esgFilter">{t("Entity.label")}</label>
							<select id="esgFilter"
								className="form-select"
								onChange={(e) => setEntity(e.target.value)}
								required
								value={filter.entity}>
								<option value='' key=''>{t('Select.label')}</option>
								{
									entities?.map((e, index) => {
										return <option value={e.id} key={e.id}>{e.name}</option>;
									})
								}
							</select>
						</div>
					}
					{
						!forCalculator &&
						<>
							<div className="col-12 p-2">
								<label htmlFor="esgFilter">{t("EmissionTable.label")}</label>
								<select id="esgFilter"
									className="form-select"
									onChange={(e) => setFilter({ ...filter, emissionTable: e.target.value })}
									required
									value={filter.emissionTable}>
									<option value='DEFRA' key='Defra'>Defra</option>
								</select>
							</div>

							<div className="col-12 p-2">

								<label htmlFor="entitiedFilter">{t("Entity.label")}</label>
								<Multiselect
									id={`entityMultiselect`}
									key={`parentEntityMultiselect`}
									options={entities}
									selectedValues={getSelectedEntities()}
									onSelect={(selectedList, selectedItem) => {
										onSelectDeSelectEntity(selectedItem);
									}}
									onRemove={(selectedList, selectedItem) => {
										onSelectDeSelectEntity(selectedItem);
									}}
									displayValue="name"
									style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
								/>
							</div>
							<div className="col-12 p-2">
								<label htmlFor="esgFilter">{t("GreenHouseGas.label")}</label>

								<select id="esgFilter"
									className="form-select"
									onChange={(e) => setFilter({ ...filter, ghgUnit: e.target.value })}
									required
									value={filter.ghgUnit}>

									<option value="" key="">
										{t("Select.label")}
									</option>
									{ghgValues.map((ghgvalue, index) => (
										<option value={ghgvalue} key={index}>
											{ghgvalue}
										</option>
									))}
								</select>
							</div>
						</>
					}
					
				</div>
			</div>
			<div className="Main_filter_footer p-2 pb-3 text-center">
				<Button variant="primary"
					onClick={() => onApplyFilter(filter)}
					className="sbmBtn px-4">
					{t("Apply.label")}
				</Button>
				<Button variant="secondary"
					onClick={() => resetFilter()}
					className="px-4 mx-2">
					{t("Reset.label")}
				</Button>
			</div>

		</div>
	);
};

export default withTranslation()(CarbonEmissionFilter);
